import { AlertNotificationCardProps } from "./alert-notification-card-types";
import { 
    AlertNotificationCardStyles, 
    ButtonContainer, 
    IconContainer, 
    Message, 
    MessageContainer, 
    Title,
    DeleteButton,
    HideButton 
} from "./style-component";
import { ExclamationCircleOutlined, CloseSquareOutlined } from '@ant-design/icons';
import { useTheme } from "@/contexts/theme-context/useThemeContext";

export const AlertNotificationCard = ({ 
    message, 
    type = 'warning', 
    onDelete, 
    onHide 
}: AlertNotificationCardProps) => {
    const { theme } = useTheme();

    const NOTIFICATION_CONFIG = {
        error: {
            icon: <CloseSquareOutlined style={{ fontSize: '16px', color: theme.colors.theme.error }} />,

            title: 'Error del Sistema'
        },
    
        warning: {
            icon: <ExclamationCircleOutlined style={{ fontSize: '16px', color: theme.colors.theme.warning }} />,
            title: 'Aviso del Sistema'
        },

        success: {
            icon: <ExclamationCircleOutlined style={{ fontSize: '16px', color: theme.colors.theme.success }} />,
            title: 'Recuperación del sistema'
        }

    };

    const config = NOTIFICATION_CONFIG[type as keyof typeof NOTIFICATION_CONFIG];

    return (
        <AlertNotificationCardStyles>
            <IconContainer>
                {config.icon}
            </IconContainer>
            <MessageContainer>
                <Title>{config.title}</Title>    
                <Message>{message}</Message>
                <ButtonContainer>
                    <DeleteButton onClick={onDelete}>
                        Borrar
                    </DeleteButton>
                    <HideButton onClick={onHide}>
                        Ocultar
                    </HideButton>
                </ButtonContainer>
            </MessageContainer>
        </AlertNotificationCardStyles>
    );
};

export default AlertNotificationCard;